// extracted by mini-css-extract-plugin
export default {"link":"Navigation_link__CFFqA","activ":"Navigation_activ__xavA2 Navigation_link__CFFqA"};